// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c91d2b86] .v-list-item--disabled {\n  opacity: 0.5;\n}\n[data-v-c91d2b86] .v-chip--select {\n  margin: 4px !important;\n}", ""]);
// Exports
module.exports = exports;
